<template></template>


<script>
export default {
  created() {
    let token = localStorage.getItem("token");
    localStorage.removeItem("token");
    Event.$emit("logout");
    this.$router.push("/");
  }
};
</script>
